module.exports = __webpack_public_path__ + "img/hero-background2.3d18107c.jpg";